import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/base.service';

export interface EstadoDistribuidorOption {
  estadoId: string;
  nome: string;
}

@Injectable({
  providedIn: 'root'
})
export class LeedService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  getEstados(): Observable<EstadoDistribuidorOption[]> {
    return this.GetValue<EstadoDistribuidorOption[]>('leed/estados');
  }

  getCidades(estado: string): Observable<string[]> {
    return this.GetValue<string[]>('leed/cidades/' + encodeURIComponent(estado || ''));
  }

  getDistribuidor(estado: string, cidade: string): Observable<any> {
    return this.GetValue<any>('leed/distribuidor?estado=' + encodeURIComponent(estado || '') + '&cidade=' + encodeURIComponent(cidade || ''));
  }

  getDashboard(): Observable<any> {
    return this.GetValue<any>('leed/dashboard');
  }

  getGerenciamentoDistribuidores(): Observable<any> {
    return this.GetValue<any>('leed/gerenciamento/distribuidores');
  }

  getGerenciamentoLeeds(filtros: any): Observable<any> {
    const usuarioFk = encodeURIComponent((filtros && filtros.usuarioFk) || '');
    const regiaoFk = encodeURIComponent((filtros && filtros.regiaoFk) || '');
    const status = encodeURIComponent((filtros && filtros.status) || '');
    const estado = encodeURIComponent((filtros && filtros.estado) || '');
    return this.GetValue<any>('leed/gerenciamento?usuarioFk=' + usuarioFk + '&regiaoFk=' + regiaoFk + '&status=' + status + '&estado=' + estado);
  }

  exportarGerenciamentoLeeds(filtros: any, ordenacao: string, direcao: string): Observable<Blob> {
    const usuarioFk = encodeURIComponent((filtros && filtros.usuarioFk) || '');
    const regiaoFk = encodeURIComponent((filtros && filtros.regiaoFk) || '');
    const status = encodeURIComponent((filtros && filtros.status) || '');
    const estado = encodeURIComponent((filtros && filtros.estado) || '');
    const coluna = encodeURIComponent(ordenacao || 'dataCadastro');
    const sentido = encodeURIComponent(direcao || 'desc');
    return this.GetFile(
      'leed/gerenciamento/exportar?usuarioFk=' + usuarioFk +
      '&regiaoFk=' + regiaoFk +
      '&status=' + status +
      '&estado=' + estado +
      '&ordenacao=' + coluna +
      '&direcao=' + sentido
    );
  }

  getGerenciamentoHistorico(leedId: string): Observable<any> {
    return this.GetValue<any>('leed/gerenciamento/' + encodeURIComponent(leedId || '') + '/historico');
  }

  getGerenciamentoDistribuidoresDestino(leedId: string, filtro: string): Observable<any> {
    const filtroValor = encodeURIComponent(filtro || '');
    return this.GetValue<any>('leed/gerenciamento/' + encodeURIComponent(leedId || '') + '/distribuidores-destino?filtro=' + filtroValor);
  }

  transferirGerenciamentoLeed(leedId: string, usuarioFk: string): Observable<any> {
    return this.PutValue('leed/gerenciamento/' + encodeURIComponent(leedId || '') + '/transferir', { usuarioFk: usuarioFk });
  }

  buscarCep(cep: string): Observable<any> {
    return this.GetValue<any>('leed/viacep/' + encodeURIComponent(cep || ''));
  }

  cadastrar(data: any): Observable<any> {
    return this.PostValueSemTratamento('leed', data);
  }

  getDashboardLeads(busca: string, status: string): Observable<any> {
    const buscaValor = encodeURIComponent(busca || '');
    const statusValor = encodeURIComponent(status || '');
    return this.GetValue<any>('leed/dashboard-leads?busca=' + buscaValor + '&status=' + statusValor);
  }

  exportarDashboardLeads(busca: string, status: string): Observable<Blob> {
    const buscaValor = encodeURIComponent(busca || '');
    const statusValor = encodeURIComponent(status || '');
    return this.GetFile('leed/dashboard-leads/exportar?busca=' + buscaValor + '&status=' + statusValor);
  }

  getDashboardLeadById(id: string): Observable<any> {
    return this.GetValue<any>('leed/dashboard-leads/' + encodeURIComponent(id || ''));
  }

  atualizarDashboardLeadStatus(id: string, status: string): Observable<any> {
    return this.PutValue('leed/dashboard-leads/' + encodeURIComponent(id || '') + '/status', { status: status });
  }

  atualizarDashboardLeadMotivoDesfesho(id: string, motivoDesfesho: string): Observable<any> {
    return this.PutValue('leed/dashboard-leads/' + encodeURIComponent(id || '') + '/motivo-desfecho', { motivoDesfesho: motivoDesfesho });
  }
}
